export default "__VITE_ASSET__orRAjg04__"